
import React, { useEffect, useState, useContext,useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import {timesheetreportService} from '../../services/timesheetreportsService';
import {timesheetService} from '../../services/timesheetService';
import {timesheetuserService} from '../../services/timesheetUserservice';
import {formatterhelper} from '../../helpers/dateformatter';
import { Paginator } from 'primereact/paginator';
import {loader} from '../../compnents/loadermd';
import { Dialog } from 'primereact/dialog';
import { FaBeer,FaCheck,FaEdit,FaRecycle,FaSearch } from "react-icons/fa";
import Smallloader from '../../compnents/loader';
import {adminService} from '../../services/adminService';
import { Toast } from 'primereact/toast';

const Addroles = ({tabname}) => {
    const toast = useRef(null);
    const [formData, setFormData] = useState({
        rolename: '',
      });
    const [datacomp,setDatacomp] = useState([]); 
    const [rdsdatacomp,setrdsDatacomp] = useState([]); 
    const [dataavail,setDatastate] = useState(false); 
    const [cleintscomp,setClientscomp] = useState([]); 
    const [subclientscomp,setsubClientscomp] = useState([]); 
    const [subtaskscomp,settaskscomp] = useState([]);
    const [subclientLoader,setSubclientloader] = useState(<></>);
    const [empcomp,setempcomp] = useState([]); 
    const [totalpages,setPages] = useState(0);
    const [filterobj,setfilterobj] = useState({});
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const [isloaded,setloading] = useState(true);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [addtimesheettoggle,settoggle] = useState(false); 
    const [editobj,seteditobj] = useState(null);
    const [errors, setErrors] = useState({});
     
    const [formData2, setForm2Data] = useState({
        selectedclient: '',
        selectedsubclient: '',
        task:'',
        minutes:'',
        billedminutes:'',
        budgethours:'',
        remainingbudgethours:'',
        count:'',
        fillingfor:'',
        remarks:''
      });
     
    useEffect(()=>{
        _getrole();
    },[]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
     };

    const handleSubmit = (e) => {
        e.preventDefault();
        addrole({role:formData});
    };

    const validateForm = () => {
        let valid = true;
        const newErrors = {};
  
        if (formData.rolename == '') {
          newErrors.rolename = 'Role name is required';
          valid = false;
        }

        setErrors(newErrors);

       return valid; 
    }

    function addrole({role}){

        if(!validateForm()){
            return;
        }
        adminService.addrolename({role:role}).then((response)=>{
        //    console.log('response'); 
        //    console.log(response); 
           if(response.status == 200){
            toast.current.show({severity:'success', summary: "Roles", detail:`Roles updated successfully!`, life: 3000});
           }else{
            toast.current.show({severity:'error', summary: "Roles", detail:`Not updated successfully!`, life: 3000}); 
           }
           setFormData({rolename:''});
           _getrole();
        }).catch((error)=>{
            toast.current.show({severity:'error', summary: "Roles", detail:`Not updated successfully!`, life: 3000}); 
        });
    } 


    function _getrole(){
        let emparr = [];
        setloading(false);

        adminService.getrole().then((response)=>{
           console.log('response'); 
        //    console.log(response.data.data); 
           response.data.data.forEach((value,index)=>{
             console.log(value.name);
             emparr.push(<tr><td>{value.id}</td><td style={{textAlign:'left'}}>{value.rolename}</td></tr>);
           });
           
           setDatacomp(emparr);
           setloading(true);
           setDatastate(true);
        //    const [datacomp,setDatacomp] = useState([]); 
        }).catch((error)=>{
            setloading(true);
            setDatastate(true);
        });
    } 


   return (
        <>
            <div className="invisible-divider-sm"></div>
            <h6 className='card-style-padding-two'>{tabname}</h6>
            <Toast ref={toast} />
            <div className='card card-custom-style card-style-padding'>
              <form onSubmit={handleSubmit}>
                <div className='row'>
                    <div className="col-md-4">
                        <label className='pull-left'>Role Name</label>
                        <br/>
                        <input type='text' name='rolename' value={formData.rolename}  onChange={(e)=>handleChange(e)} className='form-control'/>
                        {errors.rolename && <span className='error'>{errors.rolename}</span>}
                    </div>
                    <div className="col-md-3 col-sm-12">
                        <div className='button-wrapper-style'>
                            <Button type='submit' stype="button" label="Submit" severity="success" rounded className='custom-btn-style' />
                        </div>

                    </div>
                </div>
                </form>
            </div>
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding'>
              <div className='row'>
                    <div className='col-md-6'></div>
                    <div className='pagination col-md-6'>
                        {/* <PaginationExample items={totalpages} currentPaged={currentPage} lastpage={last_page} perpage={per_page} getuserfun={getUsers}/> */}
                    </div>
                </div>
               
               
                <div className='row'>
                    <div className='col-md-12'>
                    {!isloaded ? loader.Loadermd() : dataavail ?
                    (<table class="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">Id</th>
                                <th scope="col" style={{textAlign:'left'}}>Role Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {datacomp}
                        </tbody>
                    </table>) : (<p>No data Found</p>)} 
                    </div>
                   
                </div>
                <br/> 
            </div>

            <div className="invisible-divider-sm"></div>
            {/* <div className="row">
                <h1>table</h1>
            </div> */}
        </>
    );
}

export default Addroles;

